module.exports = __webpack_public_path__ + "static/media/1.a51ed409.svg";